import { SupervisorBookingStatus } from './../supervisor-booking/supervisor-booking'
import moment from 'moment-mini'

export function supervisorHaveConflicts(
  daysBusy,
  timeBlocksSupervisor,
  bookings,
  booking,
  bookingEntities,
  supervisorBookingsEntities,
  supervisorBooking,
  withSerie
): boolean {
  const hoursStartTime =
    timeBlocksSupervisor[
      moment(bookings?.startDate).isoWeekday() + '_notAvailable'
    ]?.startTime.split(':')[0]
  const minutesStartTime =
    timeBlocksSupervisor[
      moment(bookings?.startDate).isoWeekday() + '_notAvailable'
    ]?.startTime.split(':')[1]
  const hoursEndTime =
    timeBlocksSupervisor[
      moment(bookings?.startDate).isoWeekday() + '_notAvailable'
    ]?.endTime.split(':')[0]
  const minutesEndTime =
    timeBlocksSupervisor[
      moment(bookings?.startDate).isoWeekday() + '_notAvailable'
    ]?.endTime.split(':')[1]
  if (hoursStartTime && minutesStartTime && hoursEndTime && minutesEndTime) {
    // Supervisor unavailable time calendar
    if (
      moment(booking.startDate).isBefore(
        moment(booking.startDate).hours(hoursEndTime).minutes(minutesEndTime)
      ) &&
      moment(booking.startDate).isAfter(
        moment(booking.startDate)
          .hours(hoursStartTime)
          .minutes(minutesStartTime)
      )
    ) {
      return true
    }
  }

  const bookingsWhereIsSupervisor: any = Object.values(bookingEntities).filter(
    (item: any) =>
      item?.supervisors?.find((it) => it.id == supervisorBooking.personId) ||
      item?.supervisors?.includes(supervisorBooking?.personId)
  )

  let userSupervisorBookingsDay = {}
  for (const bookingsSupervisor of bookingsWhereIsSupervisor) {
    if (bookingsSupervisor.id != bookings.id) continue
    for (const supervisorBookingIds of bookingsSupervisor.supervisors) {
      const svId =
        typeof supervisorBookingIds == 'object'
          ? supervisorBookingIds.id
          : supervisorBookingIds
      if (
        svId == supervisorBooking.personId &&
        Object.values(supervisorBookingsEntities).find(
          (item: any) =>
            item.bookingId == bookingsSupervisor.id &&
            item.personId == svId &&
            (item.status == SupervisorBookingStatus.ACCEPTED ||
              item.status == SupervisorBookingStatus.DECLINED ||
              item.status == SupervisorBookingStatus.UNAVAILABLE)
        )
      ) {
        const svBk: any = Object.values(supervisorBookingsEntities).find(
          (item: any) =>
            item.bookingId == bookingsSupervisor.id && item.personId == svId
        )
        if (
          moment(bookings.startDate).isBetween(
            bookingsSupervisor.startDate,
            bookingsSupervisor.endDate
          ) ||
          moment(bookings.endDate).isBetween(
            bookingsSupervisor.startDate,
            bookingsSupervisor.endDate
          ) ||
          (withSerie &&
            bookingEntities[supervisorBookingsEntities[svBk.id].bookingId]
              .serieId == booking?.serieId)
        ) {
          userSupervisorBookingsDay[bookings.id] = {
            ...supervisorBookingsEntities[svBk.id]
          }
        }
      }
    }
  }

  if (userSupervisorBookingsDay[bookings.id]) {
    return true
  }

  if (
    {
      ...isMemberBusyInCalendar(
        daysBusy,
        supervisorBooking.supervisorInfo,
        bookings.startDate,
        bookings.endDate
      )
    }.isBusy
  ) {
    return true
  }
  if (
    {
      ...isMemberBusyInEmployeeBooking(
        daysBusy,
        supervisorBooking.supervisorInfo,
        bookings.startDate,
        bookings.endDate
      )
    }.isBusy &&
    isSupervisorBookingConfirm(
      supervisorBooking.supervisorInfo,
      bookings.startDate,
      bookings.endDate,
      supervisorBookingsEntities,
      bookingEntities
    )
  ) {
    return true
  }
  return false
}

export function isMemberBusyInCalendar(
  daysBusy,
  member,
  scheduleSlotStart,
  scheduleSlotEnd
) {
  if (!daysBusy || daysBusy.length == 0) {
    return false
  }

  let isBusyObject = { isBusy: false, filled: {}, date: {} }

  if (daysBusy && daysBusy.length > 0) {
    if (Number(moment(scheduleSlotEnd).hour()) == 0) {
      scheduleSlotEnd = moment(scheduleSlotEnd)
        .set('hours', 23)
        .set('minutes', 59)
        .set('seconds', 0)
        .set('milliseconds', 0)
        .toDate()
    }
    for (const days of daysBusy) {
      const startDay =
        moment(scheduleSlotStart).day() != 0
          ? moment(scheduleSlotStart).day()
          : 7
      const endDay =
        moment(scheduleSlotEnd).day() != 0 ? moment(scheduleSlotEnd).day() : 7
      const dayWithStartTime = moment(scheduleSlotStart)
        .set('hours', Number(days.startTime.split(':')[0]))
        .set('minutes', Number(days.startTime.split(':')[1]))
        .set('seconds', 0)
        .set('milliseconds', 0)
        .toDate()
      const dayWithEndTime = moment(scheduleSlotEnd)
        .set(
          'hours',
          Number(days.endTime.split(':')[0]) == 0
            ? 23
            : Number(days.endTime.split(':')[0])
        )
        .set(
          'minutes',
          Number(days.endTime.split(':')[0]) == 0
            ? 59
            : Number(days.endTime.split(':')[1])
        )
        .set('seconds', 0)
        .set('milliseconds', 0)
        .toDate()
      if (
        days.isoWeekDayNumber >= startDay &&
        days.isoWeekDayNumber <= endDay
      ) {
        const slotSize = moment(scheduleSlotEnd).diff(
          moment(scheduleSlotStart),
          'minutes'
        )
        if (
          moment(scheduleSlotStart) >= moment(dayWithStartTime) &&
          moment(scheduleSlotEnd) <= moment(dayWithEndTime)
        ) {
          if (!days.isAvailable) {
            isBusyObject = {
              isBusy: true,
              filled: { color: 'gray', size: 100 },
              date: {
                startHour: days.startTime,
                endHour: days.endTime
              }
            }
          }
        } else if (
          moment(dayWithStartTime) >= moment(scheduleSlotStart) &&
          moment(dayWithEndTime) <= moment(scheduleSlotEnd)
        ) {
          let particularDirection = 'start'
          if (
            moment(dayWithStartTime).diff(scheduleSlotStart) <
            moment(scheduleSlotEnd).diff(dayWithEndTime)
          ) {
            particularDirection = 'end'
          }
          if (!days.isAvailable) {
            const sizeToEnd = moment(dayWithEndTime).diff(
              moment(dayWithStartTime),
              'minutes'
            )
            if (
              slotSize / 2 >= sizeToEnd - 5 &&
              slotSize / 2 <= sizeToEnd + 5
            ) {
              isBusyObject = {
                isBusy: true,
                filled: {
                  color: 'gray',
                  size: 50,
                  direction: particularDirection
                },
                date: {
                  startHour: days.startTime,
                  endHour: days.endTime
                }
              }
            } else if (slotSize / 2 < sizeToEnd) {
              isBusyObject = {
                isBusy: true,
                filled: {
                  color: 'gray',
                  size: 75,
                  direction: particularDirection
                },
                date: {
                  startHour: days.startTime,
                  endHour: days.endTime
                }
              }
            } else if (slotSize / 2 > sizeToEnd) {
              isBusyObject = {
                isBusy: true,
                filled: {
                  color: 'gray',
                  size: 25,
                  direction: particularDirection
                },
                date: {
                  startHour: days.startTime,
                  endHour: days.endTime
                }
              }
            }
          }
        } else if (
          moment(dayWithStartTime) > moment(scheduleSlotStart) &&
          moment(dayWithStartTime) < moment(scheduleSlotEnd)
        ) {
          if (!days.isAvailable) {
            const sizeToEnd = moment(scheduleSlotEnd).diff(
              moment(dayWithStartTime),
              'minutes'
            )
            if (
              slotSize / 2 >= sizeToEnd - 5 &&
              slotSize / 2 <= sizeToEnd + 5
            ) {
              isBusyObject = {
                isBusy: true,
                filled: { color: 'gray', size: 50, direction: 'start' },
                date: {
                  startHour: days.startTime,
                  endHour: moment(scheduleSlotEnd).format('HH:mm')
                }
              }
            } else if (slotSize / 2 < sizeToEnd) {
              isBusyObject = {
                isBusy: true,
                filled: { color: 'gray', size: 75, direction: 'start' },
                date: {
                  startHour: days.startTime,
                  endHour: moment(scheduleSlotEnd).format('HH:mm')
                }
              }
            } else if (slotSize / 2 > sizeToEnd) {
              isBusyObject = {
                isBusy: true,
                filled: { color: 'gray', size: 25, direction: 'start' },
                date: {
                  startHour: days.startTime,
                  endHour: moment(scheduleSlotEnd).format('HH:mm')
                }
              }
            }
          }
        } else if (
          moment(dayWithEndTime) > moment(scheduleSlotStart) &&
          moment(dayWithEndTime) < moment(scheduleSlotEnd)
        ) {
          if (!days.isAvailable) {
            const sizeToStart = moment(dayWithEndTime).diff(
              moment(scheduleSlotStart),
              'minutes'
            )
            if (
              slotSize / 2 >= sizeToStart - 5 &&
              slotSize / 2 <= sizeToStart + 5
            ) {
              isBusyObject = {
                isBusy: true,
                filled: { color: 'gray', size: 50, direction: 'end' },
                date: {
                  startHour: moment(scheduleSlotStart).format('HH:mm'),
                  endHour: days.endTime
                }
              }
            } else if (slotSize / 2 > sizeToStart) {
              isBusyObject = {
                isBusy: true,
                filled: { color: 'gray', size: 25, direction: 'end' },
                date: {
                  startHour: moment(scheduleSlotStart).format('HH:mm'),
                  endHour: days.endTime
                }
              }
            } else if (slotSize / 2 < sizeToStart) {
              isBusyObject = {
                isBusy: true,
                filled: { color: 'gray', size: 75, direction: 'end' },
                date: {
                  startHour: moment(scheduleSlotStart).format('HH:mm'),
                  endHour: days.endTime
                }
              }
            }
          }
        }
      }
    }
  }

  return isBusyObject
}
export function isMemberBusyInEmployeeBooking(
  daysBusy,
  member,
  scheduleSlotStart,
  scheduleSlotEnd
) {
  if (!member.employeeBookings || member.employeeBookings.length == 0) {
    return false
  }

  let isBusyObject = { isBusy: false, filled: {}, date: {} }

  if (member.employeeBookings && member.employeeBookings.length > 0) {
    for (const empBook of member.employeeBookings) {
      const startDate = moment(empBook.startDate)
        .set('seconds', 0)
        .set('milliseconds', 0)
        .toDate()
      const endDate =
        Number(moment(empBook.endDate).minutes()) == 1
          ? moment(empBook.endDate)
              .set('minutes', 0)
              .set('milliseconds', 0)
              .toDate()
          : moment(empBook.endDate)
              .set('seconds', 0)
              .set('milliseconds', 0)
              .toDate()
      if (Number(moment(scheduleSlotEnd).hours()) == 0) {
        scheduleSlotEnd = moment(scheduleSlotEnd)
          .set('hours', 23)
          .set('minutes', 59)
          .toDate()
      }
      const slotSize = moment(scheduleSlotEnd).diff(
        moment(scheduleSlotStart),
        'minutes'
      )
      if (
        moment(startDate) >= moment(scheduleSlotStart) &&
        moment(endDate) <= moment(scheduleSlotEnd)
      ) {
        isBusyObject = {
          isBusy: true,
          filled: { color: 'danger', size: 100, direction: 'start' },

          date: {
            startHour: moment(empBook.startDate).format('HH:mm'),
            endHour: moment(scheduleSlotEnd).format('HH:mm')
          }
        }
      } else if (
        moment(startDate) > moment(scheduleSlotStart) &&
        moment(startDate) < moment(scheduleSlotEnd)
      ) {
        const sizeToEnd = moment(startDate).diff(
          moment(scheduleSlotStart),
          'minutes'
        )
        if (slotSize / 2 >= sizeToEnd - 5 && slotSize / 2 <= sizeToEnd + 5) {
          isBusyObject = {
            isBusy: true,
            filled: { color: 'danger', size: 50, direction: 'start' },

            date: {
              startHour: moment(empBook.startDate).format('HH:mm'),
              endHour: moment(scheduleSlotEnd).format('HH:mm')
            }
          }
        } else if (slotSize / 2 > sizeToEnd) {
          isBusyObject = {
            isBusy: true,
            filled: { color: 'danger', size: 75, direction: 'start' },
            date: {
              startHour: moment(empBook.startDate).format('HH:mm'),
              endHour: moment(scheduleSlotEnd).format('HH:mm')
            }
          }
        } else if (slotSize / 2 < sizeToEnd) {
          isBusyObject = {
            isBusy: true,
            filled: { color: 'danger', size: 25, direction: 'start' },
            date: {
              startHour: moment(empBook.startDate).format('HH:mm'),
              endHour: moment(scheduleSlotEnd).format('HH:mm')
            }
          }
        }
      } else if (
        moment(endDate) > moment(scheduleSlotStart) &&
        moment(endDate) < moment(scheduleSlotEnd)
      ) {
        const sizeToEnd = moment(scheduleSlotEnd).diff(
          moment(endDate),
          'minutes'
        )
        if (slotSize / 2 >= sizeToEnd - 5 && slotSize / 2 <= sizeToEnd + 5) {
          isBusyObject = {
            isBusy: true,
            filled: { color: 'danger', size: 50, direction: 'end' },
            date: {
              startHour: moment(scheduleSlotStart).format('HH:mm'),
              endHour: moment(empBook.endDate).format('HH:mm')
            }
          }
        } else if (slotSize / 2 < sizeToEnd) {
          isBusyObject = {
            isBusy: true,
            filled: { color: 'danger', size: 25, direction: 'end' },
            date: {
              startHour: moment(scheduleSlotStart).format('HH:mm'),
              endHour: moment(empBook.endDate).format('HH:mm')
            }
          }
        } else if (slotSize / 2 > sizeToEnd) {
          isBusyObject = {
            isBusy: true,
            filled: { color: 'danger', size: 75, direction: 'end' },
            date: {
              startHour: moment(scheduleSlotStart).format('HH:mm'),
              endHour: moment(empBook.endDate).format('HH:mm')
            }
          }
        }
      } else if (
        moment(startDate) <= moment(scheduleSlotStart) &&
        moment(endDate) >= moment(scheduleSlotEnd)
      ) {
        isBusyObject = {
          isBusy: true,
          filled: { color: 'danger', size: 100, direction: 'end' },
          date: {
            startHour: moment(startDate).format('HH:mm'),
            endHour: moment(endDate).format('HH:mm')
          }
        }
      }
    }
  }

  return isBusyObject
}

export function isMemberBusyAtSupervisor(
  member,
  scheduleSlotStart,
  scheduleSlotEnd
) {
  let isBusy = []
  if (!member.supervisorBookings || member.supervisorBookings.length == 0) {
    return []
  }

  for (const empBook of member.supervisorBookings) {
    const starDate = moment(empBook.startDate).toDate()
    const endDate = moment(empBook.endDate).toDate()
    if (
      moment(scheduleSlotStart).isBetween(moment(starDate), moment(endDate)) ||
      moment(scheduleSlotEnd).isBetween(moment(starDate), moment(endDate)) ||
      moment(starDate).isBetween(
        moment(scheduleSlotStart),
        moment(scheduleSlotEnd)
      ) ||
      moment(endDate).isBetween(
        moment(scheduleSlotStart),
        moment(scheduleSlotEnd)
      )
    ) {
      isBusy.push(empBook.id)
    }
  }

  return isBusy
}

export function isMemberBusy(
  daysBusy,
  member,
  scheduleSlotStart,
  scheduleSlotEnd,
  supervisorBookings,
  bookingEntities
) {
  if (
    (!daysBusy || daysBusy.length == 0) &&
    (!member.employeeBookings || member.employeeBookings.length == 0)
  ) {
    return false
  }

  let isBusy = false

  if (daysBusy && daysBusy.length > 0) {
    const memberCalendar: any = isMemberBusyInCalendar(
      daysBusy,
      member,
      scheduleSlotStart,
      scheduleSlotEnd
    )
    if (memberCalendar && memberCalendar.isBusy) {
      isBusy = true
    }
  }

  if (
    member.employeeBookings &&
    member.employeeBookings.length > 0 &&
    !isBusy
  ) {
    const memberEmployee: any =
      isMemberBusyInEmployeeBooking(
        daysBusy,
        member,
        scheduleSlotStart,
        scheduleSlotEnd
      ) &&
      isSupervisorBookingConfirm(
        member,
        scheduleSlotStart,
        scheduleSlotEnd,
        supervisorBookings,
        bookingEntities
      )
    if (memberEmployee && memberEmployee.isBusy) {
      isBusy = true
    }
  }

  return isBusy
}
export function isSupervisorBookingConfirm(
  member,
  scheduleSlotStart,
  scheduleSlotEnd,
  supervisorBookings,
  bookingEntities
) {
  return (
    Object.values(supervisorBookings).filter(
      (item: any) =>
        item.personId == member.id &&
        moment(bookingEntities[item.bookingId]?.startDate) >=
          moment(scheduleSlotStart) &&
        moment(bookingEntities[item.bookingId]?.endDate) <=
          moment(scheduleSlotEnd) &&
        item.status == SupervisorBookingStatus.ACCEPTED
    ).length > 0
  )
}
